export const getInitialValues = (workingHours, selectedYear) => {
  return {
    year: selectedYear,
    months: workingHours?.find(item => item.year === selectedYear)?.months.map(item => ({ month: item.month, hours: item.hours ?? '' })) ?? [],
  };
};
